import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileAcceptType, UploadType } from '../../../../../hooks';
import { AudioBlockDataItem } from '../../../../../models';
import { CloseWrapper, MediaBlockUpload, MediaBlockUploadPreview } from '../../helpers';

export const AudioNodeView: FunctionComponent<NodeViewProps> = ({
  editor,
  node,
  getPos,
  updateAttributes,
}) => {
  const { t } = useTranslation();

  const items = node.attrs.items as AudioBlockDataItem[];

  const pastedFiles = node.attrs.pastedFiles as File[] | undefined;

  const [loading, setLoading] = useState<boolean>(false);

  const content = useMemo(() => {
    const { audio = null } = { ...items[0] };

    if (audio) {
      return (
        <MediaBlockUploadPreview iconId={'audio'} label={t('richTextEditor.audio-placeholder')} />
      );
    }

    return (
      <MediaBlockUpload
        items={items}
        setItems={(items) => updateAttributes({ items })}
        pastedFiles={pastedFiles}
        loading={loading}
        setLoading={setLoading}
        fileAcceptType={FileAcceptType.AUDIO}
        uploadType={UploadType.AUDIO}
      />
    );
  }, [items, loading, pastedFiles, t, updateAttributes]);

  return (
    <NodeViewWrapper as={'div'}>
      <CloseWrapper
        editor={editor}
        node={node}
        getPos={getPos}
        loading={Boolean(loading || (pastedFiles?.length && !items.length))}
      >
        {content}
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
